import React, { useEffect, useRef, useState } from "react";
import { IoPlaySharp, IoPauseSharp } from "react-icons/io5";

// Styles
import styles from "./audio-player.module.css";

function AudioPlayer({ audio, isAudioPlaying = false, isShowControl = false }) {
  const [audioPlaying, setAudioPlaying] = useState(false);
  const [showControl, setShowControl] = useState(false);

  const audioRef = useRef(null);
  const timeoutRef = useRef(null);

  useEffect(() => {
    if (audioPlaying) {
      audioRef.current.volume = 0.7;
      audioRef.current.play();
    } else {
      audioRef.current.pause();
    }
  }, [audioPlaying]);

  useEffect(() => {
    if (audioPlaying !== isAudioPlaying) {
      setAudioPlaying(isAudioPlaying);
    }
    if (showControl !== isShowControl) {
      setShowControl(isShowControl);
    }
  }, [isAudioPlaying, isShowControl]);

  useEffect(() => {
    // Hide controls for init after 3s
    autoHideControls();

    const handleScroll = () => {
      setShowControl(true);
      clearTimeout(timeoutRef.current);

      autoHideControls();
    };

    // Add scroll event listener
    window.addEventListener("scroll", handleScroll);

    // Clean up on component unmount
    return () => {
      window.removeEventListener("scroll", handleScroll);
      clearTimeout(timeoutRef.current);
    };
  }, []);

  const handleClick = () => {
    setAudioPlaying((prev) => !prev);
    setShowControl(true);
    clearTimeout(timeoutRef.current);

    autoHideControls();
  };

  const autoHideControls = () => {
    timeoutRef.current = setTimeout(() => {
      setShowControl(false);
    }, 5000);
  };

  return (
    <div
      className={`${styles.playerContainer} ${
        showControl ? styles.show : styles.hide
      } boxShadow`}
      onClick={handleClick}
    >
      <audio src={audio} ref={audioRef} loop></audio>
      {audioPlaying ? (
        <IoPauseSharp className={styles.playerIcon} />
      ) : (
        <IoPlaySharp className={styles.playerIcon} />
      )}
    </div>
  );
}

export default AudioPlayer;
